/* eslint react/jsx-no-bind:0 */
import React from "react";
import { Switch, Route, withRouter } from "react-router-dom"
import IndexPage from "./components/layout/IndexPage"
import TeamStandingsPage  from "./components/pages/teamStandings"
import EventAveragePage from "./components/pages/eventAverage"
import SchoolAveragePage from "./components/pages/schoolAverage"
import PlayerProfilePage from "./components/pages/playerProfile"
import RankingsPage from "./components/pages/rankings"
import EventPowerPointsPage from "./components/pages/eventPowerPoints"
import TeamPowerPointsPage from "./components/pages/teamPowerPoints"
import PlayersPage from "./components/pages/players"
import TeamsPage from "./components/pages/teams"
import TeamPlayersPage from "./components/pages/teamPlayers"
import UpcomingEventsPage from "./components/pages/upcomingEvents"
import "./Vendor.js"
import "./styles/bootstrap.scss"
import "./styles/app.scss"

const App = () => (
  <Switch>
    <Route exact path="/teamStandings/:seasonId/:eventId/:eventName/:seasonName/:teamStandingsMen" component={TeamStandingsPage} />    
    <Route exact path="/eventAverage/:seasonId/:eventId/:eventName/:seasonName/:averagesMen" component={EventAveragePage} />
    <Route exact path="/schoolAverage/:seasonId/:eventId/:teamId/:eventName/:seasonName/:teamName/:averagesMen/:averagesVar" component={SchoolAveragePage} /> 
    <Route exact path="/playerProfile/:seasonId/:playerId" component={PlayerProfilePage} /> 
    <Route exact path="/rankings" component={RankingsPage} /> 
    <Route exact path="/eventPowerPoints/:seasonId/:eventId/:eventName/:seasonName/:activeDivision?" component={EventPowerPointsPage} />
    <Route exact path="/teamPowerPoints/:seasonId/:teamId/:weekNo/:teamName/:flag?" component={TeamPowerPointsPage} />
    <Route exact path="/players/:teamId?" component={PlayersPage} />
    <Route exact path="/teams" component={TeamsPage} />
    <Route exact path="/upcomingEvents" component={UpcomingEventsPage} />    
    <Route exact path="/teamPlayers/:teamId" component={TeamPlayersPage} />    
    {/* <Route exact path="/playerProfile/:seasonId/:playerId/:seasonName/:teamName" component={PlayerProfilePage} />  */}
    <Route path="/" component={IndexPage} />
  </Switch>
)
export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js